import gql from 'graphql-tag';

export const bulkAssignTeamsMutation = gql`
  mutation bulkAssignTeams(
    $serviceRequestIds: [String!]!
    $assigneeGroups: [String!]!
  ) {
    bulkAssignTeams(
      serviceRequestIds: $serviceRequestIds
      assigneeGroups: $assigneeGroups
    ) {
      successCount
      failureCount
      failures {
        serviceRequestId
        reason
      }
    }
  }
`;

